import NestedCommentSection from "../components/nestedComments";

const NestedComments = () => {
  return (
    <section className="flex container">
      <NestedCommentSection />
    </section>
  );
};

export default NestedComments;
